function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M64,45.732318 L64,45.9216696 C63.9867143,52.1304591 63.3261981,54.4110256 62.0966795,56.7100256 C60.8547415,59.0322479 59.0322479,60.8547415 56.7100256,62.0966795 C54.4110256,63.3261981 52.1304591,63.9867143 45.9216696,64 L45.732318,64 L18.267682,64 L18.0783304,64 C11.8695409,63.9867143 9.58897436,63.3261981 7.28997436,62.0966795 C4.96775214,60.8547415 3.14525855,59.0322479 1.90332051,56.7100256 L1.83023282,56.5720762 C0.659707378,54.3412301 0.0260284787,52.0534599 -5.68434189e-14,46.1067587 L-5.68434189e-14,45.9216696 L-5.68434189e-14,18.0783304 C0.0132857051,11.8695409 0.67380186,9.58897436 1.90332051,7.28997436 C3.14525855,4.96775214 4.96775214,3.14525855 7.28997436,1.90332051 L7.42792382,1.83023282 C9.6587699,0.659707378 11.9465401,0.0260284787 17.8932413,0 L18.0783304,0 L45.9216696,0 C52.1304591,0.0132857051 54.4110256,0.67380186 56.7100256,1.90332051 C59.0322479,3.14525855 60.8547415,4.96775214 62.0966795,7.28997436 C63.3261981,9.58897436 63.9867143,11.8695409 64,18.0783304 L64,18.267682 L64,45.732318 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-10.2%",
  y: "-8.6%",
  width: "120.3%",
  height: "120.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "About-_-Modal-View",
  transform: "translate(-151.000000, -567.000000)"
}, React.createElement("g", {
  id: "View",
  transform: "translate(0.000000, 190.000000)"
}, React.createElement("g", {
  id: "Item",
  transform: "translate(24.000000, 380.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(131.000000, 0.000000)"
}, React.createElement("g", {
  id: "Path"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "ic_",
  transform: "translate(16.000000, 16.000000)"
}, React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 0.460000)",
  fill: "#FFAD2F"
}, React.createElement("path", {
  d: "M28.3076923,18.4615385 L3.69230769,18.4615385 L3.69230769,6.15384615 C3.69230769,4.11446154 2.03938462,2.46153846 0,2.46153846 L0,29.5384615 L3.69230769,29.5384615 L3.69230769,27.0769231 L28.3076923,27.0769231 L28.3076923,29.5384615 L32,29.5384615 L32,23.3846154 L3.69230769,23.3846154 L3.69230769,22.1538462 L32,22.1538462 C32,20.1144615 30.3470769,18.4615385 28.3076923,18.4615385",
  id: "Fill-1"
}), React.createElement("polygon", {
  id: "Fill-3",
  points: "32 0 25.8461538 0 25.8461538 2.208 29.2061538 2.208 25.8461538 7.63815385 25.8461538 9.84615385 32 9.84615385 32 7.63815385 28.8898462 7.63815385 32 2.208"
}), React.createElement("polygon", {
  id: "Fill-5",
  points: "13.5384615 13.4440615 11.6726154 13.4440615 13.5384615 10.1874462 13.5384615 8.86190769 9.84615385 8.86190769 9.84615385 10.1874462 11.8621538 10.1874462 9.84615385 13.4440615 9.84615385 14.7696 13.5384615 14.7696"
}), React.createElement("polygon", {
  id: "Fill-7",
  points: "22.1538462 10.5409231 19.6664615 10.5409231 22.1538462 6.19753846 22.1538462 4.43138462 17.2307692 4.43138462 17.2307692 6.19753846 19.9187692 6.19753846 17.2307692 10.5409231 17.2307692 12.3083077 22.1538462 12.3083077"
})), React.createElement("g", {
  id: "Icon",
  transform: "translate(20.000000, 17.000000)"
}, React.createElement("rect", {
  id: "icon",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 10
}), React.createElement("rect", {
  id: "icon",
  fill: "#FFE72E",
  x: 2,
  y: 2,
  width: 16,
  height: 16,
  rx: 8
}), React.createElement("g", {
  id: "ic_yen",
  transform: "translate(8.000000, 6.500000)",
  stroke: "#FFFFFF",
  strokeLinecap: "square",
  strokeWidth: 1.2
}, React.createElement("line", {
  x1: 2,
  y1: 2.5,
  x2: 2,
  y2: 7.5,
  id: "Line-4"
}), React.createElement("line", {
  x1: 4,
  y1: 3.5,
  x2: 2.77555756e-17,
  y2: 3.5,
  id: "Line-4"
}), React.createElement("line", {
  x1: 4,
  y1: 0.5,
  x2: 2,
  y2: 2.5,
  id: "Line-4-Copy"
}), React.createElement("line", {
  x1: 1.81188398e-13,
  y1: 0.5,
  x2: 2,
  y2: 2.5,
  id: "Line-4-Copy"
}), React.createElement("line", {
  x1: 4,
  y1: 5.5,
  x2: -4.4408921e-16,
  y2: 5.5,
  id: "Line-4-Copy-2"
})))))))));

var SvgPic1 = function SvgPic1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPic1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pic_1.777dbb29.svg";
export { ForwardRef as ReactComponent };